/**
 * consent.ts — testo di consenso al submit pratica (F-003.4) + helper body.
 *
 * Single source of truth del testo legale mostrato all'utente al momento
 * dell'invio: usato da SubmitStep, DenseSubmitFooter e dal retry pagamento
 * (F-010 PaymentFailedPage) così l'hash inviato al backend è sempre coerente.
 */
import { sha256Hex } from '@/lib/sha256';
import type { SubmitRequestBody } from './pratica-client';

export const CONSENT_TEXT =
  'Dichiaro, assumendo piena responsabilità, che i dati inseriti nel presente form sono veritieri e corrispondono al contratto di locazione firmato dalle parti. Confermo di agire su mandato delle parti contraenti e che il documento PDF allegato è il contratto originale firmato.';

/** Costruisce il body del submit con l'hash SHA-256 del testo di consenso. */
export async function buildConsentBody(): Promise<SubmitRequestBody> {
  const consentTextHash = await sha256Hex(CONSENT_TEXT);
  return { consentGiven: true, consentTextHash };
}
